const isMobileUserAgent = (userAgent) => /iphone|ipad|ipod|android/i.test(userAgent);

export { isMobileUserAgent };
